import { render } from "./HotelView.vue?vue&type=template&id=dedd47dc&scoped=true"
import script from "./HotelView.vue?vue&type=script&lang=js"
export * from "./HotelView.vue?vue&type=script&lang=js"

import "./HotelView.vue?vue&type=style&index=0&id=dedd47dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dedd47dc"]])

export default __exports__